import { createFileRoute } from '@tanstack/react-router'
import { NewsList } from '@/features/news/pages/news-list'

export const Route = createFileRoute('/_authenticated/news/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <NewsList />
}
